import { PaymentDetailsWithRequiredScaCodeWithChallengeDataSchema } from '../schemas/payment';
import type { GlobalApiPaymentDetails } from '../types/payment';

export function getChallengeData(
  subject: GlobalApiPaymentDetails | null | undefined
) {
  const validationResult =
    PaymentDetailsWithRequiredScaCodeWithChallengeDataSchema.safeParse(subject);

  if (!validationResult.success) {
    return null;
  }

  return validationResult.data.paymentInitiationFlow.requiredInput[0]
    .challengeData;
}
